<template>
  <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16">
    <path d="M5.028 10.97h2.5l7.083-7.08a1.768 1.768 0 00-2.5-2.5L5.028 8.47v2.5m5.833-8.333l2.5 2.5m-8.333-.834h-2.5A1.667 1.667 0 00.861 5.97v7.5a1.667 1.667 0 001.667 1.667h7.5a1.667 1.667 0 001.667-1.667v-2.5" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>  </svg>
</template>
